import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    px: '16px',
    py: '10px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  message: {
    fontSize: 18,
    fontWeight: 500,
    textAlign: 'center',
    mb: 2,
  },
  customContainer: {
    padding: 1,
    backgroundColor: 'common.lightBackgroundColor',
  },
  title: {
    fontSize: 24,
    color: 'grey.500',
    my: 2,
  },
  closeContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  closeIcon: {
    color: 'common.grey350',
    margin: '10px',
    backgroundColor: 'common.lightBackgroundColor',
    padding: '3px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
